import type { Speaker } from "src/types";

export const DEFAULT_SPEAKERS: Speaker[] = [
  {
    id: 1,
    name: "Nayla O'Moore",
    first_name: "Nayla",
    last_name: "O'Moore",
    headline: "Design Director, Suzy",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/crosby/images/headshot-1.8ddfadcf.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 2,
    name: "Eduard Bauer",
    first_name: "Eduard",
    last_name: "Bauer",
    headline: "CFO, Suzy",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/crosby/images/headshot-2.a5ee24f0.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 3,
    name: "Marwah Cherry",
    first_name: "Marwah",
    last_name: "Cherry",
    headline: "CEO, Acme Inc. ",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/crosby/images/headshot-3.0d30acce.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 4,
    name: "Nazifa Greer",
    first_name: "LoNazifa",
    last_name: "Greerena",
    headline: "Founder & CEO, Suzy",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/crosby/images/headshot-4.f535c59e.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 5,
    name: "Aleksandra Walsh",
    first_name: "Aleksandra",
    last_name: "Walsh",
    headline: "CFO, CAME Co.",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/crosby/images/headshot-5.b42513b0.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 6,
    name: "Fearghal Isa",
    first_name: "Fearghal",
    last_name: "Isa",
    headline: "Head of Community, Acme Inc.",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/crosby/images/headshot-6.d985e66e.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 7,
    name: "Hermine Gale",
    first_name: "Hermine",
    last_name: "Gale",
    headline: "CEO, CAME Co.",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/crosby/images/headshot-7.f703e123.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
  {
    id: 8,
    name: "Clifford Carey",
    first_name: "Clifford",
    last_name: "Carey",
    headline: "Founder, Ecmy",
    bio: "Update this speaker or import speakers from the preference panel",
    image_url: "/canvas/crosby/images/headshot-8.c6571112.jpg",
    social: {
      linkedin_url: "https://linkedin.com",
      twitter_url: "https://twitter.com",
      website_url: "https://website.com",
    },
  },
];
